import React from "react";
import { useTranslation } from "react-i18next";
import {
	Modal,
	ModalFooterContainer,
	ModalText,
	ModalTitle,
} from "./SpinAlert.style";

const SpinAlert = ({ open, title, description, onOk }) => {
	const { t } = useTranslation();

	return (
		<Modal
			centered
			destroyOnClose
			closable={false}
			width={300}
			open={open}
			onOk={onOk}
			footer={null}
			okText={t("common.ok")}
		>
			<div style={{ textAlign: "center" }}>
				<ModalTitle>{title}</ModalTitle>
				<ModalText>{description}</ModalText>
			</div>
			<ModalFooterContainer onClick={onOk}>{t("common.ok")}</ModalFooterContainer>
		</Modal>
	);
};

export default SpinAlert;
